import React from 'react';
import { Modal, Input, notification } from 'antd';
import axios from 'axios';
import { DELETE_AGENCY } from '../../utils/Api_enums';

class DeleteInActiveModal extends React.Component {

  state = {
    tempDeleteValue: { value: '', error: '' },
    loading: false
  };


  componentWillUnmount() {
    this.onCancel(this)
  }




  handleok() {
    if (
      this.state &&
      this.state.tempDeleteValue &&
      this.state.tempDeleteValue.value.split(' ').join(' ').trim().toLowerCase() === 'delete'
    ) {
      this.setState({
        tempDeleteValue: { ...this.state.tempDeleteValue, error: '' }, // NOSONAR
        loading: true
      });
      axios.put(DELETE_AGENCY(this.props.agency.id)).then(res => {
        if (res.data && res.data.status == "success") {
          notification.success({ message: res.data.message })
          // notification.success({ message: 'Deleted Successfully' })
          if (this.props.clearSearch) {
            this.props.clearSearch();
          }
           this.onCancel(this);
          this.props.loadAllAgencies();
        } else {
          notification.error({ message: 'Unable to Delete' })
        }
      })

    } else {
      this.setState({
        tempDeleteValue: {
          ...this.state.tempDeleteValue, // NOSONAR
          error: 'Please enter "delete" in the textfield to delete the agency.',
        },
        loading: false
      });
    }
  }

  onCancel = (that) => {
    that.setState({
      tempDeleteValue: { value: '', error: '' },
      agency: {},
      loading: false
    });
    that.props.hideModal()
  }


  tempDeleteValue = (e) => {
    this.setState({ tempDeleteValue: { ...this.state.tempDeleteValue, value: e.target.value } })  // NOSONAR
  }

  render() {
    return (
      <div>

        <Modal
          confirmLoading={this.state.loading}
          className="custom-delete-modal"
          title='Are you sure you want to delete Agency including Users, &nbsp; &nbsp; B Files & appointments?'
          visible={this.props.showModal}
          onCancel={() => this.onCancel(this)}
          maskClosable={false}
          onOk={this.handleok.bind(this)}
          okText="Delete"
          okType='danger'
          okButtonProps={{ disabled: this.state.tempDeleteValue.value.trim().split(' ').join(' ').toLowerCase() !== 'delete' }}
        >
          <div>
            <h4 style={{ color: this.state.tempDeleteValue.error ? "red" : "" }}>Please enter ‘Delete’ in textbox below to confirm deletion</h4>
            <div>
              <Input
                onChange={(e) => this.tempDeleteValue(e)}
                placeholder="Please Enter Delete"
                style={{ width: '82%' }}
                value={this.state.tempDeleteValue.value || ''}
              />
            </div>
          </div>
        </Modal>
      </div>
    );
  }
}

export default DeleteInActiveModal;



// WEBPACK FOOTER //
// ./src/scenes/SuperAdmin/delete-inactive-modal.js